module.exports = __webpack_public_path__ + "65db6a35b0083f56e53104dc5e590f5d.MP3";